import { Actions, IExecuteConfig, ISpreadsheetConfig } from "../types";
import { isRangeId, checkSpanByNames, showAlert, getCellsArray, isCellSpaned } from "../helpers/main";
import { IGrid } from "@dhx/ts-grid";
import locale from "../locales/en";
import { DataPage } from "@xbs/muon";

export class Merge {
	protected _handlers: { [key: string]: (...args) => void };
	private _callAction: (config: IExecuteConfig) => void;
	private _isLocked: (cell: string) => boolean;
	private _config: ISpreadsheetConfig;
	private _grid: IGrid;

	constructor(cb, config, grid, isLocked) {
		this._callAction = cb;
		this._config = config;
		this._grid = grid;
		this._isLocked = isLocked;
	}

	doAction(cell: string, remove: boolean) {
		if (!this.checkBeforeMerge(cell, remove)) return;

		const action = Actions[remove ? "unmerge" : "merge"];
		this._callAction({
			action,
			groupAction: action,
			cell,
		});
	}

	checkBeforeMerge(cell: string, remove: boolean) {
		if (!isRangeId(cell) && !remove) return false;
		const { topSplit, leftSplit } = this._config;
		if (topSplit || leftSplit) {
			if (!checkSpanByNames(cell, leftSplit, topSplit, this._grid)) {
				showAlert(locale.spanMergeAlert);
				return false;
			}
		}

		const locked = getCellsArray(cell, this._grid).find(c => this._isLocked(c));
		if (locked) {
			showAlert(locale[remove ? "spanUnmergeLockedError" : "spanMergeLockedError"]);
			return false;
		}
		return true;
	}

	checkBeforeAction(cell, page: DataPage, action: string) {
		const { merged } = page.getMeta();
		let span;
		const cellsArr = getCellsArray(cell, this._grid);
		cellsArr.forEach(cell => {
			const s = isCellSpaned(cell, merged, this._grid);
			if (s) {
				span = s;
			}
		}, cell);
		if (span) {
			const message = locale.mergeAlertMessage.split("$action");
			showAlert(`${message[0]} ${action.toLowerCase()} ${message[1] || ""}`);
			return false;
		}
		return true;
	}
}
